import React from 'react';
import { AssessmentLevel } from 'src/shared/types/src';

const TierLegends = ({assessmentLevels}: {assessmentLevels: AssessmentLevel[]}) => {
  return (
    <>
      {
        assessmentLevels.length > 0 ? <>
          <div className='observation-tier-legends'>
            {
              assessmentLevels.map((level: AssessmentLevel, index: number) => {
                return (
                  <div className='observation-tier-legends-item' key={index}>
                    <span className="observation-legend-dot tag-dot-print" style={{ color: level.color }}>●</span>
                    <div className='observation-legend-dot print-element-hide' style={{ backgroundColor: level.color }}></div>
                    <div className='fs-10 fw-regular text-black'>{ level.name }</div>
                  </div>
                )
              })
            }
          </div>
        </> : null
      }
    </>
    
  );
};

export default TierLegends;
